// EffectGenerationStyle is an object representing effect generation style.
const EffectGenerationStyle = {
  NoStyle: 'none',
  Enhance: 'enhance',
  Anime: 'anime',
  Photographic: 'photographic',
  DigitalArt: 'digital-art',
  ComicBook: 'comic-book',
  FantasyArt: 'fantasy-art',
  LineArt: 'line-art',
  AnalogFilm: 'analog-film',
  NeonPunk: 'neon-punk',
  Isometric: 'isometric',
  LowPoly: 'low-poly',
  Origami: 'origami',
  ModelingCompound: 'modeling-compound',
  Cinematic: 'cinematic',
  ThreeDModel: '3d-model',
  PixelArt: 'pixel-art',
  TileTexture: 'tile-texture',
};

Object.freeze(EffectGenerationStyle);

export default EffectGenerationStyle;


// EffectGenerationStylePreset represents a preset for effect generation style.
export class EffectGenerationStylePreset {
    constructor(data) {
        this.ID = data.id;
        this.style = data.style;
        this.imageURL = data.image_url;
    }
}
